import { ProductSuggestion } from './product-suggestion';

export { ProductSuggestion };
